import './Auth.css';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import { useLocation, useNavigate } from 'react-router-dom';
import google from '../../Assets/Images/RegisterPage/social.png';

import {  VerifyForgotPasswordToken } from '../../services/auth.jsx';
import { useState } from 'react';

function ForgotPassword(){
    const navigate = useNavigate();

    const location=useLocation();

    const query=new URLSearchParams(location.search);

    const token=query.get('token');

    const [error,setError]=useState('')

    const [isDisabled, setIsDisabled] = useState(false);

    const passwordRegex=/^(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    function validationPassword(data)
    {
        if(!passwordRegex.test(data.password))
        {
            setError('Password must include one Uppercase letter, one special character, and at least 8 characters long');
            return false;
        }
        if(data.password!==data.cpassword)
        {
            setError("Password does not match!");
            return false;
        }
        return true;
    }
    async function HandleSubmit(e)
    {
       e.preventDefault();
       
       const form=new FormData(e.target);
       const data=Object.fromEntries(form.entries());

       console.log(data);
       if(!validationPassword(data)) return;

       setIsDisabled(true);

       const forgotPassword=await VerifyForgotPasswordToken({token,'newPassword':data.password});
       
       if(forgotPassword && forgotPassword.success)
       {
           navigate('/successfullpasswordreset');
       }
       else
       {
          setError(forgotPassword);
       }
    }
    return(
        <>
             <div className='logincontainer'>
                    <form className='loginform' onSubmit={(e)=>HandleSubmit(e)}>
                           <h2>Reset the password</h2>
                           <h3>Please enter your registered email ID</h3>
                           <section className='logininput'>
                           <input type='text' name='password' placeholder='Enter new password'/>
                           <input type='password' name='cpassword' placeholder=' Confirm Password'/>
                           </section>
                           <section className='loginbuttons'>
                           <label style={{marginBottom:'5px',color:'var(--border-color)'}}>{error}</label>
                                <button className='loginbutton' disabled={isDisabled} style={{marginBottom:"20px"}}>SUBMIT</button>
                                {/* <div className='orsection'>
                                    <hr  class="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  class="custom-hr"/>
                                </div> */}
                            </section>
                    </form>
                    {/* <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} alt='linkedIn' width="38" height="38"/>
                            </section> */}
                            <h4>  Already have an account ?<span  onClick={()=>window.location.href="/login"}> Login</span></h4>
             </div>
        </>
        );

}

export default ForgotPassword;